<template>
  <div>
    <div>
      <Echart
      style="z-index:1"
        id="nationalMapChart"
        ref="nationalMapChartRef"
        :options="options"
        height="80vh"
        width="60vw"
      ></Echart>
    </div>

    <div class="right_time">
      <div v-if="this.area==0" class="quan">全国交通新闻</div>
      <ul class="newsList" :class="newsShow ? 'showlist' : ''">
        <li
          class="mapNewsList"
          v-for="(item, index) in newsList.slice(0,6)"
          :key="index"
        >
          <div class="listboxtips">
            <div class="tip">
              <p>{{ item.date }}</p>
              <p>{{ item.source }}</p>
            </div>
          </div>
       
             <h3 @click="geList(item)" class="mainTitle">
            {{ item.title }}
          </h3>
           <p  v-if="item.content=='null'" class="subTitle">
            {{ item.content}}
          </p>
          <p v-else class="subTitle">
            {{ item.content}}
          </p>
         
        </li>
      </ul>
    </div>
    
    <el-dialog
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
   <div class="body_tiele">{{this.list.title}} <img class="body_img" @click="goDetail(list.netURL)" src="@/assets/lian.png" alt=""> </div>
    <div class="live">{{this.list.source}}<div>{{this.list.date}}</div></div>
    <div  class="body_cont">
       {{this.list.content}}
       <div class="time_img" >
        <div class="wx_img" v-for="(item,index) in imgs" :key="index">
         <img v-if="item.imgUrl!=''" class="img_wx" :src="item.imgUrl" alt="">
     
        </div>
        </div> 
    </div>
  <span slot="footer" class="dialog-footer">
    
  </span>
</el-dialog>
  </div>
</template>

<script>
import Echart from "@/common/echart";
import { mapNum, mapMon } from "@/api/map.js";
export default {
  data() {
    return {
      newsShow: false,
      newsList: [],
      options: {},
      geoCoordMap: "",
      area: 110000, //区域码
      // area:0,
      proName: "浙江省", //省
      dialogVisible: false,
      // proCity:''    //市
      list:{},
      num:0,
      text:'',
      netURL:'',
      imgs:[]
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.getNewsList();

  },
  watch: {
    // area(value){
    //  console.log(value,'jianing')
    // },
    cdata: {
      handler(newData) {
        // 设置点的位置(经纬度)
        this.geoCoordMap = {
         北京市: [116.41667, 39.91667],
           天津市: [117.2, 39.13333],
           河北: [115.48333, 38.03333],
          山西省: [112.53333, 37.86667],
        内蒙古自治区: [111.670801, 41.818311],
         辽宁省: [123.38333, 41.8],
           吉林省: [125.35, 43.88333],
          黑龙江省: [127.63333, 47.75],
         上海市: [121.55333, 31.2],
          江苏省: [119.78333, 32.05],
        浙江省: [120.2, 30.26667],
          安徽省: [117.283042, 31.86119],
         福建省: [118.3, 26.08333],
        江西省: [115.9, 28.68333],
         山东省: [117.000923, 36.675807],
          河南省: [113.65, 34.76667],
          湖北省: [114.298572, 30.584355], 
         湖南省: [113.0, 28.21667],
         广东省: [113.23333, 23.16667],
         广西壮族自治区: [108.320004, 22.82402],
          海南省: [110.35, 20.01667],
            重庆市: [106.45, 29.56667],
           四川省: [104.06667, 30.66667],
            贵州省: [106.71667, 26.56667],
           云南省: [102.73333, 25.05],
           西藏自治区: [91.0, 30.6],
           陕西省: [108.95, 34.26667],
          甘肃省: [103.73333, 36.03333],
          青海省: [96.75, 36.56667],
          宁夏回族自治区: [106.26667, 37.46667],
         新疆维吾尔自治区: [87.68333, 43.76667],
         台湾省: [121.3, 25.03],
         香港特别行政区: [114.1, 22.2],
           澳门特别行政区: [113.5, 22.2]  
         
        
          // 山东: [117.000923, 36.675807],
          // 河北: [115.48333, 38.03333],
          // 吉林: [125.35, 43.88333],
          // 黑龙江: [127.63333, 47.75],
          // 辽宁: [123.38333, 41.8],
          // 内蒙古自治区: [111.670801, 41.818311],
          // 新疆维吾尔自治区: [87.68333, 43.76667],
          // 甘肃: [103.73333, 36.03333],
          // 宁夏回族自治区: [106.26667, 37.46667],
          // 山西省: [112.53333, 37.86667],
          // 陕西: [108.95, 34.26667],
          // 河南: [113.65, 34.76667],
          // 安徽: [117.283042, 31.86119],
          // 江苏: [119.78333, 32.05],
          // 浙江: [120.2, 30.26667],
          // 福建: [118.3, 26.08333],
          // 广东: [113.23333, 23.16667],
          // 江西: [115.9, 28.68333],
          // 海南: [110.35, 20.01667],
          // 广西壮族自治区: [108.320004, 22.82402],
          // 贵州: [106.71667, 26.56667],
          // 湖南: [113.0, 28.21667],
          // 湖北: [114.298572, 30.584355],
          // 四川省: [104.06667, 30.66667],
          // 云南: [102.73333, 25.05],
          // 西藏自治区: [91.0, 30.6],
          // 青海: [96.75, 36.56667],
          // 天津市: [117.2, 39.13333],
          // 上海市: [121.55333, 31.2],
          // 重庆市: [106.45, 29.56667],
          // 北京市: [116.41667, 39.91667],
          // 台湾: [121.3, 25.03],
          // 香港特别行政区: [114.1, 22.2],
          // 澳门特别行政区: [113.5, 22.2],
        };
        let seriesData = [];
        let convertData = function(data) {
          let scatterData = [];
          for (var i = 0; i < data.length; i++) {
            var geoCoord = this.geoCoordMap[data[i].name];
            if (geoCoord) {
              scatterData.push({
                name: data[i].name,
                value: geoCoord(data[i].value),
          
              });
            }
          }
          return scatterData;
        };
        this.options = {
          showLegendSymbol: true,
          tooltip: {
            trigger: "item",
            textStyle: {
              fontSize: 14,
              lineHeight: 22,
            },
            position: (point) => {
              // 固定在顶部
              return [point[0] + 20, point[1] - 15];
            },
            // 如果需要自定义 tooltip样式，需要使用formatter
            /*
              formatter: params => {
                return `<div style=""> ... </div>`
              }
            */
          },
          visualMap: {      //左下角视图容器
            min: 0,
            max: 2300,
            show: true,
            right: "auto", //组件离容器右侧的距离,'20%'
            bottom: "10%", //组件离容器下侧的距离,'20%'
            seriesIndex: 0,
            calculable: true,
            itemWidth: 20, //图形的宽度，即长条的宽度。
            itemHeight: 140, //图形的高度，即长条的高度。
            text: ["高", "低"],
            textStyle: {
              color: "#24CFF4",
            },
            // 颜色
            inRange: {
              color: ["rgba(41,166,206, .5)", "rgba(69,117,245, .9)"],
            },
          },
          // 底部背景
          geo: {
            show: true,
            aspectScale: 0.85, //长宽比
            zoom: 1.2,
            top: "10%",
            left: "10%",
            map: "china",
            roam: false,
            itemStyle: {
              normal: {
                areaColor: "rgba(0,0,0,0)",
                shadowColor: "rgba(7,114,204, .8)",
              },
              emphasis: {
                areaColor: "#00aeef",
              },
            },
          },
          series: [
            {
              name: "相关指数",
              type: "map",
              aspectScale: 0.85, //长宽比
              zoom: 1.2,
              mapType: "china", // 自定义扩展图表类型
              top: "10%",
              left: "10%",
              itemStyle: {
                normal: {
                  color: "red",
                  areaColor: "rgba(19,54,162, .5)",
                  borderColor: "rgba(0,242,252,.3)",
                  borderWidth: 1,
                  shadowBlur: 7,
                  shadowColor: "#00f2fc",
                },
                emphasis: {
                  areaColor: "#4f7fff",
                  borderColor: "rgba(0,242,252,.6)",
                  borderWidth: 2,
                  shadowBlur: 10,
                  shadowColor: "#00f2fc",
                },
              },
              label: {
                formatter: (params) => `${params.name}`,
                show: false,
                position: "insideRight",
                textStyle: {
                  fontSize: 14,
                  color: "#efefef",
                },
                emphasis: {
                  textStyle: {
                    color: "#fff",
                  },
                },
              },
              data: newData,
            },
            {
              // 散点图
              type: "effectScatter",
              coordinateSystem: "geo",
              symbolSize: 7,
              effectType: "ripple",
              legendHoverLink: false,
              showEffectOn: "render",
              rippleEffect: {
                period: 4,
                scale: 2.5,
                brushType: "stroke",
              },
              zlevel: 1,
              itemStyle: {
                normal: {
                  color: "#99FBFE",
                  shadowBlur: 5,
                  shadowColor: "#fff",
                },
              },
              data: convertData(seriesData),
            },
          ],
        };
        // 重新选择区域
        this.handleMapRandomSelect();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    geList(item){
      this.dialogVisible=true
      this.list=item
     var data1=item.imgs
 var demArray1 =[];
var demArray1 = data1.map(item => {
     return {
        imgUrl: item
        }
      })
  this.imgs=demArray1
    },
     handleClose(done) {
       this.dialogVisible=false
      },
    // 开启定时器
    startInterval() {
      const _self = this;
      // 应通过接口获取配置时间，暂时写死5s
      const time = 10000;
      if (this.intervalId !== null) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        _self.reSelectMapRandomArea();
      }, time);
    },
    // 重新随机选中地图区域
    reSelectMapRandomArea() {
      const length = 34;
      this.$nextTick(() => {
        try {
          const map = this.$refs.nationalMapChartRef.chart;
          // let index = Math.floor(Math.random() * length);
          let index=this.num++;
          if(index==34){
            this.num=0
            window.reload()
          }
            // console.log(index,this.num,'获取的下标')
          while (index === this.preSelectMapIndex || index >= length) {
            // index = Math.floor(Math.random() * length);
          let index=this.num++;
          if(index==34){
            this.num=0
            window.reload()
          }
          }
          map.dispatchAction({
            type: "mapUnSelect",
            seriesIndex: 0,
            dataIndex: this.preSelectMapIndex,
          });
          map.dispatchAction({
            type: "showTip",
            seriesIndex: 0,
            dataIndex: index,
          });

          map.dispatchAction({
            type: "mapSelect",
            seriesIndex: 0,
            dataIndex: index,
          });
          this.preSelectMapIndex = index;
          switch (this.preSelectMapIndex) {
            case 14:
              this.area = 370000;
              this.text='山东',
              this.getNewsList();
              break;
            case 2:
              this.area = 130000;
              this.text='河北',
              this.getNewsList();
              break;
            case 6:
              this.area = 220000;
              this.text='吉林',
              this.getNewsList();
              break;
            case 7:
              this.area = 230000;
              this.text='黑龙江',
              this.getNewsList();
              break;
            case 5:
              this.area = 210000;
              this.text='辽宁',
              this.getNewsList();
              break;
            case 4:
              this.area = 150000;
              this.text='内蒙古',
              this.getNewsList();
              break;
            case 30:
              this.area = 650000;
              this.text='新疆',
              this.getNewsList();
              break;

            case 27:
              this.area = 620000;
              this.text='甘肃',
              this.getNewsList();
              break;
            case 29:
              this.area = 640000;
              this.text='宁夏',
              this.getNewsList();
              break;
            case 3:
              this.area = 140000;
              this.text='山西',
              this.getNewsList();
              break;
            case 26:
              this.area = 610000;
              this.text='陕西',
              this.getNewsList();
              break;
            case 15:
              this.area = 410000;
              this.text='河南',
              this.getNewsList();
              break;
            case 11:
              this.area = 340000;
              this.text='安徽',
              this.getNewsList();
              break;
            case 9:
              this.area = 320000;
              this.text='江苏',
              this.getNewsList();
              break;
            case 10:
              this.area = 330000;
              this.text='浙江',
              this.getNewsList();
              break;
            case 12:
              this.area = 350000;
              this.text='福建',
              this.getNewsList();
              break;
            case 18:
              this.area = 440000;
              this.text='广东',
              this.getNewsList();
              break;
            case 13:
              this.area = 360000;
              this.text='江西',
              this.getNewsList();
              break;
            case 20:
              this.area = 460000;
              this.text='海南',
              this.getNewsList();
              break;
            case 19:
              this.area = 450000;
              this.text='广西',
              this.getNewsList();
              break;
            case 23:
              this.area = 520000;
              this.text='贵州',
              this.getNewsList();
              break;
            case 17:
              this.area = 430000;
              this.text='湖南',
              this.getNewsList();
              break;
            case 16:
              this.area = 420000;
              this.text='湖北',
              this.getNewsList();
              break;
            case 22:
              this.area = 510000;
              this.text='四川',
              this.getNewsList();
              break;
            case 24:
              this.area = 530000;
              this.text='云南',
              this.getNewsList();
              break;
            case 25:
              this.area = 540000;
              this.text='西藏',
              this.getNewsList();
              break;
            case 28:
              this.area = 630000;
              this.text='青海',
              this.getNewsList();
              break;
            case 1:
              this.area = 120000;
              this.text='天津',
              this.getNewsList();
              break;
            case 8:
              this.area = 310000;
              this.text='上海',
              this.getNewsList();
              break;
            case 21:
              this.area = 500000;
              this.text='重庆',
              this.getNewsList();
              break;
            case 0:
              this.area = 110000;
              this.text='北京',
              this.getNewsList();
              break;
            case 31:
              this.area = 710000;
              this.text='台湾',
              this.getNewsList();
              break;
            case 32:
              this.area = 810000;
              this.text='香港',
              this.getNewsList();
              break;
            case 33:
              this.area = 820000;
              this.text='澳门',
              this.getNewsList();
            case 34:
              this.area=0;
              this.text='全国',
              this.getNewsList();
          }
        } catch (error) {
          // console.log(error);
        }
      });
    },
    handleMapRandomSelect() {
      this.$nextTick(() => {
        try {
          const map = this.$refs.nationalMapChartRef.chart;
          const _self = this;
          // setTimeout(() => {
          //   _self.reSelectMapRandomArea();
          // }, 3000);
          // 移入区域，清除定时器、取消之前选中并选中当前

          map.on("click", function(params) {
          _self.text=params.data.name
          // _self.proName=params.data.name
            if (params.data.name == "新疆") {
              this.proName = params.data.name + "维吾尔自治区";
            } else if (
              params.data.name == "内蒙古" ||
              params.data.name == "西藏"
            ) {
              this.proName = params.data.name + "自治区";
            } else if (
              params.data.name == "澳门" ||
              params.data.name == "香港"
            ) {
              this.proName = params.data.name + "特别行政区";
            } else if (params.data.name == "广西") {
              this.proName = params.data.name + "壮族自治区";
            } else if (params.data.name == "宁夏") {
              this.proName = params.data.name + "回族自治区";
            } else if (
              params.data.name == "北京" ||
              params.data.name == "重庆" ||
              params.data.name == "上海" ||
              params.data.name == "天津"
            ) {
              this.proName = params.data.name + "市";
            } else {
              this.proName = params.data.name + "省";
            }
            console.log(this.proName,'省份')
            mapNum({
              proName: this.proName,
            }).then((res) => {
              if (res.data.code == 200) {
                _self.area = res.data.data.id;
                console.log(_self.area, "当前区域码");
                _self.getNewsList();
              }
            });

            clearInterval(_self.intervalId);
            map.dispatchAction({
              type: "mapUnSelect",
              seriesIndex: 0,
              dataIndex: _self.preSelectMapIndex,
            });
            map.dispatchAction({
              type: "mapSelect",
              seriesIndex: 0,
              dataIndex: params.dataIndex,
            });

            _self.preSelectMapIndex = params.dataIndex;
          });
          // 移出区域重新随机选中地图区域，并开启定时器
          map.on("globalout", function() {
            // _self.reSelectMapRandomArea();
            _self.startInterval();
          });

          this.startInterval();
        } catch (error) {
          // console.log(error);
        }
      });
    },
    // 打开新页面
    goDetail(url) {
          window.open(url);
    },
    // 右侧新闻数据更新
    getNewsList() {
      mapMon({
         area: this.area,
         text: this.text
         }).then((res) => {
        this.newsList = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.quan{
  position: absolute;
  top: -30px;
  right: 0;
  font-weight: bold;
  text-align: center;
  line-height: 20px;
  color: #fff;
  font-size: 24px;
  width: 28.39vw;
  height: 20px;
}
.time_img{
  width: 100%;
  height: 5vh;
  display: flex;
// justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.wx_img{
padding: 10px;
.img_wx{
  width:170px;
  height: 140px;
}
}
.body_tiele{
  font-size: 30px;
font-family: PingFang;
font-weight: bold;
color: #FFFFFF;
line-height: 36px;
text-align: center;
}
.body_img{
  position: relative;
  left: 5px;
  cursor: pointer;
}
.live{
  width: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  margin: 0 auto;
  font-size: 18px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #60D6DD;
}
.body_cont{
  width: 90%;
  height: 60vh;
 overflow-y: scroll;
  margin: 0 auto;
  font-size: 22px;
font-family: Microsoft YaHei;
font-weight: 400;
line-height: 28px;
color: #FFFFFF;
}
.map_time {
  width: 100vh;
  height: 100vh;
  display: flex;
  justify-content: space-around;
}

.right_time {
  width: 100px;
  // height: 200px;
  .newsList {
    position: absolute;
    height: 80vh;
    right: 0;
    top: 0;
    width: 28.39vw;
    // padding-top: 6vh;
 
    .mapNewsList {
      position: relative;
      color: #fff;
      margin-bottom: 0.6vh;
      padding: 0.54vw;
      height:13vh;
      .listboxtips {
        width: 10vw;
        font-size: 0.73vw;
        text-align: right;
        position: absolute;
        left: calc(-11vw - 1vh);
        padding-right: 2vw;
        line-height: 2;
        height: 100%;
        white-space: nowrap;
        .tip {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
      .listboxtips:after {
        content: "";
        position: absolute;
        width: 1vh;
        height: 1vh;
        border-radius: 50%;
        top: 50%;
        margin-left: 0.5vw;
        margin-right: 0.5vw;
        background: #9fb4d6;
      }
      .mainTitle {
        font-size: 24px;
        line-height: 1.4;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .subTitle {
        font-size: 18px;
        // margin-top: 1vh;
        line-height: 1.4;
        color: #ddd;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: off */
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .mapNewsList:nth-of-type(1) {
      transition-delay: 0.2s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(2) {
      transition-delay: 0.2s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(3) {
      transition-delay: 0.4s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(4) {
      transition-delay: 0.6s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(5) {
      transition-delay: 0.8s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(6) {
      transition-delay: 1s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(7) {
      transition-delay: 1.2s;
      background: rgba(53, 120, 221, 0.3);
    }
  }
  .showlist {
    .mapNewsList:nth-child(n) {
      // opacity: 1;
      transform: translate(0, 0);
      -webkit-transform: translate(0, 0);
    }
  }
}
</style>
